import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ptBr from "../../config/texts/pt-br";
import {
  ButtonContained,
  CustomText,
  DefaultLogo,
  InputEmail,
  InputPassword,
} from "../../components/index";
import Styles from "./styles";
import { FormFull } from "form-full";
import { validations } from "../../utils";
import { hooks, SessionStorage } from "../../utils";
import { StorageContext } from "../../contexts/StorageContext";

import { api } from "../../services";
import { paths } from "../../navigation/navigate";
import { customModal } from "../../components/modals/utils";
import NewPasswordRegistry from "./components/NewPasswordRegistry";
import { FaKey } from "react-icons/fa6";
import SelectComponent from "../../components/inputs/Select";
import { log } from "console";

function Login() {
  const texts = ptBr.login;

  const openNewPasswordModal = () => {
    customModal.setInfos(
      "Alteração de Senha",
      [],
      null,
      null,
      <NewPasswordRegistry onSubmit={() => null} />,
      null,
      null,
      <FaKey />
    );
  };

//   [
//     {
//         "id": "VNCpUHlrm7qXcUL6xoFLcA==",
//         "name": "CONDOMINIO TUYA"
//     },
//     {
//         "id": "kUsI09iNU8RUfd9V6p78lA==",
//         "name": "CONDOMINIO MIBO"
//     }
// ]

  const navigate = useNavigate();
  const { loading, call } = hooks.useRequest();
  const { setUserData, setIsLogged, addData, logOut, getData } = useContext<any>(StorageContext);
  //utilizado para lógica de verificação se é primeiro usuario (apagar depois)
  const [isFirstLogin, setFirstLogin] = useState<boolean>(false);

  const Submit = async (data) => {
    data.username = (data.username + "").toLocaleLowerCase();
    call(
      null,
      api.getToken({ username: data.username, password: data.password }),
      (response) => {
        if (response.ok) {
          call(null, api.getCondominium(), (res) => {
            if (res.ok) {
              addData("condominiumList", res.data);
              SessionStorage.setItem("condominiumList", JSON.stringify(res.data));
              addData("company_type", res.data[0]?.id);
              SessionStorage.setItem("company_type", res.data[0]?.id);
              setIsLogged(true);
              SessionStorage.setItem("company_type", data?.company);
            call(null, api.getUserData(), (response) => {
              if (response.ok) {
                SessionStorage.setItem("userData", response?.data);
                setUserData(response.data);
                /*Implementar integração de primeiro usuário e finalizar 
                lógica se é primeiro usuário e se é gestor ou proprietário*/
                if (isFirstLogin) {
                  openNewPasswordModal();
                } else {
                  navigate(paths.myProperties);
                }
              }
            });
            } else {
              logOut();
              customModal.setInfos(
                "Erro",
                [],
                null,
                null,
                <CustomText>{res.message}</CustomText>,
                null,
                null,
                <FaKey />
              );
            }
          });
          
        }
      }
    );
  };

  const [buttonDisabled, setButton] = React.useState(true);

  return (
    <Styles.ImageBG>
      <FormFull onSubmit={Submit}>
        <Styles.Content>
          <Styles.Header>
            <DefaultLogo maxWidth={200} />
          </Styles.Header>
          <Styles.Title>{texts.title}</Styles.Title>
          <Styles.Subtitle>{texts.subtitle}</Styles.Subtitle>
          <InputEmail
            name="username"
            alternative
            label={texts.user}
            required={texts.userMessage}
            validation={validations.isEmailValid}
            placeholder="email@exemplo.com.br"
          />
          <InputPassword
            name="password"
            label={texts.password}
            required={texts.passwordMessage}
            validation={validations.isPassword}
            onChange={() => {
              setButton(false);
            }}
            placeholder="Digite sua senha"
          />
          {/* <SelectComponent
            required={texts.passwordMessage}
            label="EMPREENDIMENTO*"
            name="company"
            options={[
              { label: "ON", value: "ON" },
              { label: "UP", value: "UP" },
            ]}
          /> */}
          <Styles.ButtonContainer>
            <Styles.ForgotPasswordButton
              onClick={() => navigate(paths.forgetPassword)}
            >
              {texts.forgotPass}
            </Styles.ForgotPasswordButton>
          </Styles.ButtonContainer>
          <Styles.EnterButton
            name="submit"
            loading={loading}
            disabled={buttonDisabled}
            feedback={true}
            action="submit"
            type="submit"
            label={texts.enter}
          />
          <CustomText style={{ justifyContent: "center" }}>
            {process.env.REACT_APP_ENV + " v"}
            {process.env.REACT_APP_VERSION}
          </CustomText>
        </Styles.Content>
      </FormFull>
    </Styles.ImageBG>
  );
}

export default Login;
